






































import { Component, Watch, Vue } from 'vue-property-decorator';
import { KonvaEventObject, Node } from 'konva/types/Node';
import { gsap, TweenLite } from 'gsap';
import { format } from 'date-fns';
import Timeline from './Timeline.vue';
import events from '../data/events';
import { Evnt } from '../__types';
import {
  sortEventsByDate,
  getEventsByParticipant,
  getEventPoint,
  getEventsPoints,
  getClosestEventToDate,
  getEventIndex,
} from '../utils/eventsUtils';
import arrow from '../assets/sort-up-solid.svg';

@Component({
  components: {
    Timeline,
  },
})
export default class TimelineWrapper extends Vue {
  setCurrentEventById(id: string) {
    this.$store.dispatch('events/setCurrentEventById', id);
  }

  get currentEvent() {
    return this.$store.getters['events/getCurrentEvent'];
  }

  events = sortEventsByDate(events);
  getEventsByParticipant = getEventsByParticipant;
  participants = [
    'frodoSam',
    'gandalf',
    'merryPippin',
    'aragorn',
    'boromir',
    'legolasGimli',
  ];
  colors = ['#cb997e', '#457b9d', '#a5a58d', '#e07a5f', '#8d99ae', '#81b29a']; // colors for timelines
  firstEvent = this.events[0];
  lastEvent = this.events[this.events.length - 1];
  points = getEventsPoints(this.events, 20);
  currentAnimation: ReturnType<typeof TweenLite.to> | null = null; // reference of most recent animation, it's needed to kill it if new dragging starts before animation ended
  image = new Image(); // image for arrows to jump between events
  innerWidth = window.innerWidth;

  configTimelineWrapper = {
    x: 0,
    y: 0,
    height: window.innerHeight * 0.2,
    draggable: true,
    dragBoundFunc: this.dragLimit,
  };

  configWrapperBg = {
    x: -window.innerWidth / 2,
    y: 0,
    width:
      getEventPoint(this.lastEvent, 20) -
      getEventPoint(this.firstEvent, 20) +
      window.innerWidth,
    height: window.innerHeight * 0.2,
  };

  get center() {
    return Math.ceil(this.innerWidth / 2 - this.configTimelineWrapper.x);
  }

  get configDateMark() {
    return {
      x: this.center,
      y: 30,
      points: [0, 0, 0, this.participants.length * 20 + 4],
      stroke: '#444444',
      strokeWidth: 2,
      lineCap: 'round',
    };
  }

  get configDate() {
    return {
      text: format(
        new Date(
          this.firstEvent.date.valueOf() + (this.center / 20) * 86400000,
        ),
        'dd MMMM yyyy',
      ),
      x: this.center,
      y: 10,
      width: 200,
      offsetX: 100,
      align: 'center',
      fontSize: 14,
      fontFamily: 'anironregular',
    };
  }

  get configDateMinus() {
    return {
      image: this.image,
      x: this.center - 150,
      y: 30,
      width: 20,
      height: 30,
      rotation: -90,
    };
  }

  get configDatePlus() {
    return {
      image: this.image,
      x: this.center + 150,
      y: 10,
      width: 20,
      height: 30,
      rotation: 90,
    };
  }

  addEvents() {
    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth;
    });
  }

  dragLimit(pos: { x: number; y: number }): { x: number; y: number } {
    // limit dragging to horizontal only
    return {
      x: pos.x,
      y: (this.$refs.timelineWrapper as Vue & { getNode: () => Node}).getNode().absolutePosition().y,
    };
  }

  changeCursor({ target }: KonvaEventObject<MouseEvent>, cursor: string): void {
    const container = target.getStage()?.container();
    if (container) container.style.cursor = cursor;
  }

  onDragMove({ target }: KonvaEventObject<MouseEvent>): void {
    if (this.currentAnimation) {
      this.currentAnimation.kill();
    }
    this.configTimelineWrapper.x = target.x();
  }

  onDragEnd(): void {
    const closest = getClosestEventToDate(
      this.events,
      new Date((this.center * 86400000) / 20 + this.firstEvent.date.valueOf()),
    );
    if (closest) this.setCurrentEventById(closest.id);
  }

  scrollToDate(date: Date): void {
    const pos = { x: this.configTimelineWrapper.x };
    const anim = gsap.to(pos, {
      x:
        -(((date.valueOf() - this.firstEvent.date.valueOf()) / 86400000) * 20) +
        window.innerWidth / 2,
      duration: 1,
      ease: 'power3.out',
      onUpdate: () => {
        this.configTimelineWrapper.x = pos.x;
      },
    });
    this.currentAnimation = anim;
  }

  jumpToPastEvent(): void {
    const currentEventIndex = getEventIndex(events, this.currentEvent);
    if (currentEventIndex >= 1) {
      this.setCurrentEventById(this.events[currentEventIndex - 1].id);
    }
  }

  jumpToNextEvent(): void {
    const currentEventIndex = getEventIndex(events, this.currentEvent);
    if (currentEventIndex >= 0 && currentEventIndex < this.events.length - 1) {
      this.setCurrentEventById(this.events[currentEventIndex + 1].id);
    }
  }

  addImg(): void {
    this.image.src = arrow as string;
  }

  created() {
    this.addImg();
  }

  mounted() {
    this.addEvents();
    setTimeout(() => this.setCurrentEventById('hobbiton-3018-04-12'), 2000);
  }

  @Watch('currentEvent')
  onCurrentEventChange(newEvent: Evnt): void {
    this.scrollToDate(newEvent.date);
  }
}
